import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyhole2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"keyhole-2, lock, unlock"} maskId="square-filled-radius-0-stroke-1-IconKeyhole2"><path d="M12 2C15.866 2 19 5.13401 19 9C19 11.6328 17.5459 13.9242 15.3994 15.1191L17.4746 21.3418L17.6934 22H6.30664L8.59961 15.1191C6.45352 13.9241 5 11.6325 5 9C5 5.13401 8.13401 2 12 2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconKeyhole2;
